import { render, staticRenderFns } from "./WhatsappConnectSettings.vue?vue&type=template&id=7433e64a&"
import script from "./WhatsappConnectSettings.vue?vue&type=script&lang=js&"
export * from "./WhatsappConnectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports